// extracted by mini-css-extract-plugin
export default {"views":"styles_views__MMcm1"};